import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import TopBanner from './TopBanner';
import Header from './Header';
import Footer from './Footer';
import FinancialTicker from './FinancialTicker';
import { fetchTicker } from '../services/newsService';

export default function Layout() {
  const location = useLocation();
  const [ticker, setTicker] = useState([]);
  const showTicker = location.pathname === '/' || location.pathname === '/category/financials';

  useEffect(() => {
    let mounted = true;
    fetchTicker().then((t) => mounted && setTicker(t));
    return () => { mounted = false; };
  }, []);

  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);

  return (
    <div className="App min-h-screen flex flex-col bg-[#f7fbf9]">
      <TopBanner />
      <Header />
      {showTicker && <FinancialTicker items={ticker} />}
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
